const Default = {
	init: function() {

		//hack to prevent tribe event calendar from doing their broken js page redirects
		$('.tribe-events-l-container').find('a').on('click', function(e){
			window.location.href = $(this).attr('href');
			e.preventDefault();
		})
	}
}

export default Default;